import { TitleEntityForm } from '../../features/TitleEntityForm';
import { apiRequests } from '../../shared/api/apiRequests';

const CreateCategoryOfPortfolioPage = () => (
  <TitleEntityForm
    create={apiRequests.portfolio.createCategory}
    backTo="/portfolio/categories"
    placeholder="Например, Мобильные приложения"
    createdText="Категория создана"
  />
);

export default CreateCategoryOfPortfolioPage;
